module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAAXNSR0IArs4c6QAAASBJREFUOE+t0s9K1VEUxfHPllCRBFMQfAafoWmNjBBsKoFEA8EoInIQRQlJSmlUBP0Z6Cs07BUa+iolGktO/K6UXbsJnvE637322quc86tz5vkFTDKBr/iCp1V1cJZBSW60f1jpAWewh3FsYbWq9v8HmmQRrzGG5eOVkyzgAy52ggeDoEludtpRPMeTPzJMMo9PndO3uF9VP/o5TbLUbTOCNTxrUf11lCTX8RGX8A73TkKT3MJLDDdXWO/l3vfKSebwGZN4j7tV9T1J09/GJi7gETaq6rC3xam1SXKtW79BW7Z30DLbwBAe48XvsAb9Zw+TXMUupvANsx1sFa+q6ufJfAcWO8kV7GAarUoPsd0PNtBhb3qSy1093rQYToM1/REz/V+54xVJIwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/top22.png
// module id = +rkt
// module chunks = 0